// TOS page elements
const TOS = () => {
	return (
		<>
			<h1>terms of service</h1>
			<h2>idk rn</h2>
		</>
	);
};

// Export
export default TOS;
